export default "__VITE_ASSET__Pfuw4dRk__"